<template>
  <div class="task-detail-section">
    <TaskDetailGeneralSection />
    <TaskDetailPointSection
      v-show="selectedPointIdx !== null"
      :fleetTaskInstantId="$route.params.id"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TaskDetailGeneralSection from './TaskDetailGeneralSection'
import TaskDetailPointSection from './TaskDetailPointSection'

export default {
  components: {
    TaskDetailGeneralSection,
    TaskDetailPointSection,
  },
  computed: {
    ...mapState('fleetTaskInstant', ['selectedPointIdx']),
  },
}
</script>
<style lang="scss">
.task-detail-section {
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
